import { Sparkles } from 'lucide-react';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../../../components/ui/dialog';
import { CHANGELOG } from '../../../shared/config/changelog';

function formatDate(iso: string): string {
  return new Date(`${iso}T12:00:00`).toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

interface ChangelogDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/** Что изменилось в приложении — списком, свежее сверху. */
export function ChangelogDialog({ open, onOpenChange }: ChangelogDialogProps): JSX.Element {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[80vh] overflow-y-auto sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Sparkles className="h-4 w-4 text-primary" />
            Что нового
          </DialogTitle>
          <DialogDescription>Последние изменения в InstaFarm</DialogDescription>
        </DialogHeader>

        <div className="space-y-6">
          {CHANGELOG.map((entry) => (
            <section key={entry.date} className="space-y-2">
              <div>
                <h3 className="text-sm font-semibold">{entry.title}</h3>
                <p className="text-xs text-muted-foreground">{formatDate(entry.date)}</p>
              </div>
              <ul className="space-y-1.5">
                {entry.items.map((item) => (
                  <li key={item} className="flex gap-2 text-sm text-muted-foreground">
                    <span aria-hidden className="mt-1.5 size-1 shrink-0 rounded-full bg-primary/60" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
